import React, { useState, useEffect, useRef } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { db } from 'src/config/firebase';
import {connect} from 'react-redux';
import videojs from 'video.js';
import RewindIcon from 'src/assets/images/content/videoRewind.png';
import bgIcon from 'src/assets/images/content/bg.png';
import 'video.js/dist/video-js.css';

const useStyles = makeStyles((theme) => ({
  videoContainer:{
    position:'relative',
  },

  videoComp:{
    '&.video-js':{
      borderRadius:'20px',
      height:'562px !important',

      [theme.breakpoints.between('xs','md')]: {
        height:'220px !important',
        borderRadius:'0px'
      }
    },
    '&.video-js .vjs-tech':{
      borderRadius:'20px',
      [theme.breakpoints.between('xs','md')]: {
        borderRadius:'0px'
      }
    },

    '&.video-js .vjs-control-bar':{
      paddingLeft:'5px',
      paddingRight:'5px',
      borderBottomLeftRadius:'20px',
      borderBottomRightRadius:'20px',
      backgroundPosition:'bottom',
      backgroundRepeat:'repeat-x',
      opacity:0.7,
      backgroundImage: `url(${bgIcon})`,
      [theme.breakpoints.between('xs','md')]: {
        borderBottomLeftRadius:'0px',
        borderBottomRightRadius:'0px',
      }
    },

    '.video-js .vjs-volume-level':{
      backgroundColor:'#0D273E'
    },

    '&.video-js .vjs-big-play-button':{
      justifycontent: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      lineHeight: 2.3,
      borderRadius: '50%',
      border: '4px solid #fff',
      width:'117px',
      height:'117px',
      fontSize:'5em',

      [theme.breakpoints.between('xs','md')]: {
        width:'43px',
        height:'43px',
        border:'2px solid #fff',
        fontSize:'2.2em',
        lineHeight:1.8
      }
    },

    '&.vjs-has-started .vjs-big-play-button':{
      display:'none !important'
    },

    '& .vjs-rewind-button': {
      zIndex: 10, /* Ensure buttons are above video content */
      backgroundSize: 'contain', /* Ensure image fits well */
      backgroundRepeat: 'no-repeat',
      cursor: 'pointer',
    },

    '& .vjs-forward-button': {
      display: 'inline-block',
      backgroundSize: 'contain', /* Ensure the image fits well */
      backgroundRepeat: 'no-repeat', /* Prevent image repetition */
      backgroundPosition: 'center', /* Center the image */
      cursor: 'pointer',
    }
  },

  videoComp2:{
    '&.video-js':{
      borderRadius:'20px',
      height:'100% !important',

      [theme.breakpoints.between('xs','md')]: {
        height:'220px !important',
        borderRadius:'0px'
      }
    },
    '&.video-js .vjs-tech':{
      borderRadius:'20px',
      [theme.breakpoints.between('xs','md')]: {
        borderRadius:'0px'
      }
    },

    '&.video-js .vjs-control-bar':{
      paddingLeft:'5px',
      paddingRight:'5px',
      borderBottomLeftRadius:'20px',
      borderBottomRightRadius:'20px',
      backgroundPosition:'bottom',
      backgroundRepeat:'repeat-x',
      opacity:0.7,
      backgroundImage: `url(${bgIcon})`,
      [theme.breakpoints.between('xs','md')]: {
        borderBottomLeftRadius:'0px',
        borderBottomRightRadius:'0px',
      }
    },

    '.video-js .vjs-volume-level':{
      backgroundColor:'#0D273E'
    },

    '&.video-js .vjs-big-play-button':{
      justifycontent: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      lineHeight: 2.3,
      borderRadius: '50%',
      border: '4px solid #fff',
      width:'117px',
      height:'117px',
      fontSize:'5em',

      [theme.breakpoints.between('xs','md')]: {
        width:'43px',
        height:'43px',
        border:'2px solid #fff',
        fontSize:'2.2em',
        lineHeight:1.8
      }
    },

    '&.vjs-has-started .vjs-big-play-button':{
      display:'none !important'
    },

    '& .vjs-rewind-button': {
      zIndex: 10, /* Ensure buttons are above video content */
      backgroundSize: 'contain', /* Ensure image fits well */
      backgroundRepeat: 'no-repeat',
      cursor: 'pointer',
    },

    '& .vjs-forward-button': {
      display: 'inline-block',
      backgroundSize: 'contain', /* Ensure the image fits well */
      backgroundRepeat: 'no-repeat', /* Prevent image repetition */
      backgroundPosition: 'center', /* Center the image */
      cursor: 'pointer',
    }
  },

  watermark: props=> ({
    width: '100%',
    position: 'absolute',
    color: props?.color ? props?.color : 'rgba(0, 0, 0, 0.2)',
    fontSize: props?.fontSize ? `${props?.fontSize}px` : '15px',
    zIndex: 9999,
    opacity: props?.opacity ? props?.opacity : 0.5,
    fontWeight: "bold",
    userSelect: "none",
    display:'flex',
    flexDirection:'column',
    justifyContent:'flex-end',
    fontFamily: "Cairo, sans-serif",
    pointerEvents: 'none', // Ensures watermark doesn't interfere with video interactions
    [theme.breakpoints.between('xs','md')]: {
      fontSize:'12px'
    }
  }),

   pointerNone:{
    pointerEvents:'none'
   },

   // Custom Rewind Button
  rewindButton: {
    width: '40px',
    height: '40px',
    background: 'url(/path/to/rewind-icon.png) no-repeat center',
    backgroundSize: 'contain',
    display: 'inline-block',
    cursor: 'pointer',
  },

  // Custom Forward Button
  forwardButton: {
    width: '40px',
    height: '40px',
    background: 'url(/path/to/forward-icon.png) no-repeat center',
    backgroundSize: 'contain',
    display: 'inline-block',
    cursor: 'pointer',
  },

   playbackRateButton: {
    color: 'white',
    fontSize: '14px',
    padding: '0 10px',
    display: 'inline-block',
    cursor: 'pointer',
  },
}));

const initPositions = [
  { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }
];

const _positions = {
  'topLeft':{ top: '20px', left: '20px', textAlign:'left' },
  'topRight':{ top: '20px', right: '20px', textAlign:'right' },
  'bottomLeft':{ bottom: '40px', left: '20px', textAlign:'left' },
  'bottomRight':{ bottom: '40px', right: '20px', textAlign:'right' },
  'center': { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' },
};

const addRewindButton = (player) => {
  const Button = videojs.getComponent('Button');

  // Define RewindButton using ES6 class inheritance
  class RewindButton extends Button {
    constructor() {
      super(player);
      this.controlText("Rewind 10 seconds");
      this.addClass('vjs-rewind-button');
      this.el().innerHTML = ''; // Clear default icon
      this.el().style.backgroundImage = `url(${RewindIcon})`; // Set your custom image
    }

    handleClick() {
      const currentTime = player.currentTime();
      player.currentTime(Math.max(0, currentTime - 10)); // Rewind by 10 seconds
    }
  }

  // Register and add the RewindButton
  videojs.registerComponent('RewindButton', RewindButton);
  player.controlBar.addChild('RewindButton', {}, 0); // Insert after play button
};

const addForwardButton = (player) => {
  const Button = videojs.getComponent('Button');

  // Define ForwardButton using ES6 class inheritance
  class ForwardButton extends Button {
    constructor() {
      super(player);
      this.controlText("Forward 10 seconds");
      this.addClass('vjs-forward-button');
      this.el().innerHTML = ''; // Clear default icon
      this.el().style.backgroundImage = `url(${RewindIcon})`; // Set your custom image
    }

    handleClick() {
      const currentTime = player.currentTime();
      const duration = player.duration();
      player.currentTime(Math.min(duration, currentTime + 10)); // Forward by 10 seconds
    }
  }

  // Register and add the ForwardButton
  videojs.registerComponent('ForwardButton', ForwardButton);
  player.controlBar.addChild('ForwardButton', {}, 3); // Insert after rewind button
};

export const VideoJS = (props) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  let {options, onReady, studentName, studentEmail, duration, customCls, singleSession, bookingContent, company, demoTest } = props;
  const [currentPositionIndex, setCurrentPositionIndex] = useState(0);
  const [watermarkSetting, setWatermarkSetting] = useState({});
  const intervalRef = useRef(null);
  const companyId = company?.id || '';
  const { fontSize, position=[], watermarkMoving=false, color, transparency } = watermarkSetting || {};
  const opacity = transparency !== undefined ? Number(transparency) / 100 : 1;
  const classes = useStyles({fontSize,color,opacity});

  const positions = position?.length ? !watermarkMoving ? [_positions?.[position[0]]] : position?.map(v=> _positions[v]) : !watermarkMoving ? [initPositions[0]] : initPositions;

  useEffect(()=> {
    function getWatermark() {
      if(companyId) {
        db.ref(`Companies/${companyId}/watermarkSetting/`).on('value',(data)=> {
          const watermarkSetting = data.val();
          if(watermarkSetting) setWatermarkSetting(watermarkSetting);
        })
      }
    };

    getWatermark();
  },[companyId])


  useEffect(() => {

    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
      const videoElement = document.createElement("video-js");

      videoElement.classList.add('vjs-big-play-centered');
      videoElement.classList.add(demoTest ? classes.videoComp2 : classes.videoComp);
      videoElement.setAttribute('playsinline', 'playsinline'); // Add this line
      videoRef.current.appendChild(videoElement);
      
      // iOS fullscreen handling
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const _options = {
        ...options,
        controlBar: {
          pictureInPictureToggle:false,
        },
        ...(isIOS ? 
          {
            nativeControlsForTouch: false,
            controlBar: {
              pictureInPictureToggle:false,
              fullscreenToggle: false, // Allow the fullscreen toggle but use Video.js fullscreen
            }
          }
          :
          {}
        ),
        playbackRates: [0.5, 1, 1.5, 2],
      }
      
      const player = playerRef.current = videojs(videoElement, _options, () => {
        videojs.log('player is ready');
        onReady && onReady(player);

        addForwardButton(player);
        addRewindButton(player);

      });

      if(duration) player.currentTime(duration || 0);

      const watermark = document.createElement('div');
      watermark.className = classes.watermark;
      watermark.id = 'watermark';
      const nameDiv = document.createElement('span');
      nameDiv.innerText = studentName;

      const emailDiv = document.createElement('span');
      emailDiv.innerText = studentEmail;
      watermark.appendChild(nameDiv);
      watermark.appendChild(emailDiv);
      videoElement.appendChild(watermark);

      intervalRef.current = setInterval(() => {
        setCurrentPositionIndex(prevIndex => (prevIndex + 1) % positions.length);
      }, 3000);

      player.on('play', handlePlay);
      player.on('pause', handlePause);

      // Fullscreen event listener
      player.on('fullscreenchange', () => {
        if (player.isFullscreen()) {
          watermark.style.display = 'flex'; // Show watermark in fullscreen
        } else {
          watermark.style.display = 'flex'; // Adjust as needed
        }
      });

      if (isIOS) {
        player.on('webkitbeginfullscreen', () => {
          watermark.style.display = 'flex'; // Show watermark in iOS fullscreen
        });
        player.on('webkitendfullscreen', () => {
          watermark.style.display = 'flex'; // Revert on exit fullscreen
        });
      }

      return () => {
        clearInterval(intervalRef.current);
      } 

    // You could update an existing player in the `else` block here
    // on prop change, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.src(options.sources);
      if(duration) player.currentTime(duration || 0);

    }
  }, [options, videoRef]);

  

  useEffect(()=> {
    if(watermarkMoving) {
      intervalRef.current = setInterval(() => {
        setCurrentPositionIndex(prevIndex => (prevIndex + 1) % positions.length);
      }, 3000);
    }
    else{
      clearInterval(intervalRef.current);
    }

    return () => {
      clearInterval(intervalRef.current);
    } 
  },[watermarkMoving])

  useEffect(() => {
    const player = playerRef.current;
  
    if (player) {
      const tech = player.tech(true);
      
      if (!singleSession && !bookingContent) {
        player.pause();
  
        // Safely remove event listeners only if the player and tech are available
        if (tech) {
          tech.off('click'); // Disable click event on video element
        }
  
        player.off('play', handlePlay); // Disable play event
        player.off('pause', handlePause); // Disable pause event
      } else {
        // Re-enable the events if disablePlayer is false
        player.on('play', handlePlay);
        player.on('pause', handlePause);
  
        // Ensure the tech element is accessible before adding listeners
        if (tech) {
          tech.on('click', () => {
            console.log('Video clicked');
          });
        }
      }
    }
  }, [singleSession]);

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
      URL.revokeObjectURL(options.sources?.[0]?.['src']);
    };
  }, [playerRef]);

  useEffect(() => {
    const player = playerRef.current;

    const resizeWatermark = () => {
      // const videoWidth = player.videoWidth();
      const videoElement = player.el().querySelector('video');
      if (videoElement) {
        const { width: renderedWidth } = videoElement.getBoundingClientRect();
        const watermark = document.getElementById('watermark');
        const scale = renderedWidth / 800; // Example: scale based on video width (800 is an arbitrary base size)
        const dynamicFontSize = fontSize ? `${fontSize}px` : `${3 * scale}rem`;
        if(watermark) {
          watermark.style.fontSize = dynamicFontSize;
        }
      }
    };

    player.ready(() => {
      resizeWatermark();
    });
  
    player.on('resize', () => {
      resizeWatermark();
    });
  }, [playerRef,fontSize]);

  useEffect(() => {
    const watermark = document.getElementById('watermark');
    const position = !watermarkMoving ? positions?.[0] : positions[currentPositionIndex];
    if (watermark && position && Object?.keys(position)?.length) {
      watermark.style.top = position?.top || 'auto';
      watermark.style.right = position?.right || 'auto';
      watermark.style.bottom = position?.bottom || 'auto';
      watermark.style.left = position?.left || 'auto';
      watermark.style.textAlign = position?.textAlign || 'left';
      if(position?.top === '50%') {
        watermark.style.transform = position?.transform;
      }
      else{
        watermark.style.transform = 'unset';
      }
    }
  }, [currentPositionIndex,positions]);


  const handlePlay = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        setCurrentPositionIndex(prevIndex => (prevIndex + 1) % positions.length);
      }, 3000);
    }
  };

  const handlePause = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  const disableContextMenu = (e) => {
    e.preventDefault();
  };

  return (
    <div className={`${classes.videoContainer} ${customCls || ''} ${!singleSession && !bookingContent ? classes.pointerNone : null}`} data-vjs-player  onContextMenu={disableContextMenu}>
      <div ref={videoRef} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
      singleSession: state.singleSession,
      company: state.company
  }
}

export default connect(mapStateToProps,null)(VideoJS);